import Oauth from '@/utils/oauth'

const mixin = {
  computed: {
    $auth() {
      return Oauth
    },
  },
}

export default {
  install(Vue) {
    Vue.mixin(mixin)
  },
}
